__turbopack_context__.v({
  "container": "U2Phjq_container",
  "divider": "U2Phjq_divider",
  "item": "U2Phjq_item",
  "list": "U2Phjq_list",
  "title": "U2Phjq_title",
  "wrapper": "U2Phjq_wrapper",
});
